import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { Countdown } from './ui/Countdown';
export function UrgencySection() {
  return <section className="bg-slate-950 text-center text-white" aria-label="Offerta a tempo limitato" data-id="element-212" data-mp="2sk46nkhn1yb1">
      <div className="h-1 w-full bg-amber-400" aria-hidden="true" data-id="element-213" data-mp="36bimxjk5vlee" />
      <div className="mx-auto max-w-3xl px-4 py-12" data-id="element-214" data-mp="31iz8kkdngm8j">
        <p className="inline-flex items-center gap-2 text-sm font-bold uppercase tracking-[.16em] text-amber-400" data-id="element-215" data-mp="31hefkz6zhbcs">
          <AlertTriangleIcon className="h-4 w-4" aria-hidden="true" data-id="element-216" data-mp="3b90wnc6064ng" /> Il prezzo di lancio termina tra
        </p>
        <Countdown className="mt-5" data-id="element-217" data-mp="3p9bsktm669fh" />
        <p className="mt-7 font-bold text-slate-300" data-id="element-218" data-mp="3p8a33k4epke8">Dopo, il prezzo aumenta e non tornerà più così basso.</p>
      </div>
      <div className="h-1 w-full bg-amber-400" aria-hidden="true" data-id="element-219" data-mp="3l53zylclc9bz" />
    </section>;
}